var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"survey-questions-counter",style:(_vm.style)},_vm._l((Array(_vm.total).fill('')),function(_,idx){return _c('div',{key:idx + 1,staticClass:"counter-marker",class:{ colored: _vm.current >= idx }})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }